<template>
    <div>
        <template v-if="newType === 'checkbox'">
            <div
                class="form-group checkbox"
                :class="errors.has(name) ? 'error' : ''"
                style="
                    display: inline-block;
                    margin-bottom: 35px;
                    padding-left: 25px;
                "
            >
                <label
                    style="
                        margin-top: 0px;
                        font-size: 14px;
                        color: #3a3a3a;
                        pointer-events: all;
                        position: relative;
                        left: auto;
                        top: auto;
                        display: block;
                        margin-bottom: 0px;
                        vertical-align: middle;
                        padding-left: 1px;
                        text-transform: none;
                    "
                >
                    <input
                        v-validate="validate"
                        type="checkbox"
                        :name="name"
                        :checked="current"
                        @change="input"
                        style="margin-left: -25px; width: auto; float: left"
                    />
                    <span v-html="label"></span>
                    <span v-if="errors.has(name)" class="errors">
                        - {{ errors.first(name) }}
                    </span>
                </label>
            </div>
        </template>
        <template v-if="newType === 'text'">
            <div
                class="form-group text"
                :class="errors.has(name) ? 'error' : ''"
            >
                <label :class="value ? 'label-focus' : ''"
                    >{{ label }}
                    <span v-if="errors.has(name)" class="errors">
                        - {{ errors.first(name) }}
                    </span></label
                >
                <input
                    v-validate="validate"
                    type="text"
                    :list="name"
                    :name="name"
                    :value="value"
                    @input="input"
                    @blur="onBlur"
                />

                <div
                    v-if="autocompleteElements.length > 0"
                    class="autocomplete-list"
                >
                    <ul>
                        <li
                            v-for="autocompleteElement in autocompleteElements"
                            :key="autocompleteElement.id"
                            class="autocomplete-element"
                            @click="selectAutocomplete(autocompleteElement)"
                        >
                            {{ autocompleteElement.properties.full_address }}
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    inject: ["$validator"],
    props: {
        name: String,
        type: String,
        label: String,
        value: [String, Number],
        validate: String,
        change: Function,
        showAutocomplete: Boolean,
        autocompleteElements: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            current: this.value,
        };
    },
    computed: {
        newType() {
            if (!this.type) {
                return "text";
            }
            return this.type;
        },
    },
    methods: {
        selectAutocomplete(place) {
            this.$emit("selectAutocomplete", place, this.name);
        },
        input(e) {
            if (this.newType === "checkbox") {
                this.current = e.target.checked;
            }
            if (this.newType === "text") {
                this.current = e.target.value;
            }
            this.current = e.target.value;
            this.$emit("input", this.current);
        },
        onBlur() {
            setTimeout(() => {
                this.$emit("blur");
            }, 200);
        },
    },
};
</script>
<style lang="scss">
.autocomplete-list {
    z-index: 1;
    width: auto;
    outline: black solid 1px;
    padding: 8px;
    position: absolute;
    top: 64px;
    background-color: white;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        li {
            padding: 16px;
        }

        li:hover {
            cursor: pointer;
            background: #00a7af;
            color: white;
        }
    }
}
</style>
